var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section-home"},[_c('h3',[_vm._v("Cientos de desafíos para aprender, crear y compartir")]),_vm._v(" "),_c('img',{staticStyle:{"padding-top":"50px","padding-bottom":"50px"},attrs:{"src":"public/images/site/challenges.svg","id":"challenges","alt":"Miles de proyectos"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5533d43a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/startPage/ProjectBanner.vue
// module id = 423
// module chunks = 0